// BrandsPage.jsx - Similar structure
import React, { useState, useEffect, useRef } from 'react';
import { AgGridReact } from 'ag-grid-react';
import 'ag-grid-community/styles/ag-grid.css';
import 'ag-grid-community/styles/ag-theme-alpine.css';
import { getBrands, addBrand, updateBrand, deleteBrand } from '../../utils/api';
import { BrandModal } from './BrandModal';

export const BrandsPage = () => {
    const [rowData, setRowData] = useState([]);
    const [showModal, setShowModal] = useState(false);
    const [isEdit, setIsEdit] = useState(false);
    const [currentBrand, setCurrentBrand] = useState(null);
    const gridRef = useRef();

    useEffect(() => {
        fetchBrands();
    }, []);

    const fetchBrands = async () => {
        try {
            const res = await getBrands();
            setRowData(res.data);
        } catch (err) {
            console.error(err);
        }
    };

    const columnDefs = [
        { field: 'id', headerName: 'ID', filter: true, sortable: true },
        { field: 'name', headerName: 'Name', filter: true, sortable: true, flex: 2 },
        {
            field: 'image',
            headerName: 'Image',
            cellRenderer: (params) => <img src={params.value} alt={params.data.name} className="w-16 h-16 object-cover" />,
            width: 100
        },
        { field: 'created_at', headerName: 'Created', filter: 'agDateColumnFilter', sortable: true },
        {
            headerName: 'Actions',
            cellRenderer: (params) => (
                <div className="flex space-x-2">
                    <button onClick={() => handleEdit(params.data)} className="px-2 py-1 bg-blue-500 text-white rounded text-sm">Edit</button>
                    <button onClick={() => handleDelete(params.data.id)} className="px-2 py-1 bg-red-500 text-white rounded text-sm">Delete</button>
                </div>
            ),
            width: 150
        }
    ];

    const defaultColDef = {
        resizable: true,
        sortable: true,
        filter: true
    };

    const onGridReady = (params) => {
        gridRef.current.api = params.api;
    };

    const handleAdd = () => {
        setIsEdit(false);
        setCurrentBrand(null);
        setShowModal(true);
    };

    const handleEdit = (brand) => {
        setIsEdit(true);
        setCurrentBrand(brand);
        setShowModal(true);
    };

    const handleDelete = async (id) => {
        if (window.confirm('Are you sure?')) {
            try {
                await deleteBrand(id);
                fetchBrands();
            } catch (err) {
                console.error(err);
            }
        }
    };

    const handleModalClose = () => {
        setShowModal(false);
        setCurrentBrand(null);
    };

    const handleModalSubmit = async (formData) => {
        try {
            if (isEdit && currentBrand) {
                await updateBrand(currentBrand.id, formData);
            } else {
                await addBrand(formData);
            }
            fetchBrands();
            handleModalClose();
        } catch (err) {
            console.error(err);
        }
    };

    return (
        <div className="bg-white p-6 rounded shadow">
            <div className="flex justify-between items-center mb-6">
                <h1 className="text-2xl font-bold">Brands</h1>
                <button onClick={handleAdd} className="px-4 py-2 bg-green-500 text-white rounded">Add Brand</button>
            </div>
            <div className="ag-theme-alpine" style={{ height: 500, width: '100%' }}>
                <AgGridReact
                    ref={gridRef}
                    rowData={rowData}
                    columnDefs={columnDefs}
                    defaultColDef={defaultColDef}
                    onGridReady={onGridReady}
                    animateRows={true}
                />
            </div>
            <BrandModal
                show={showModal}
                onClose={handleModalClose}
                onSubmit={handleModalSubmit}
                isEdit={isEdit}
                currentItem={currentBrand}
            />
        </div>
    );
};